"use client"

import { Parentheses } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ParenthesesIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ParenthesesIcon = component(Icon)({ as: Parentheses })
